// extracted by mini-css-extract-plugin
export default {"sectionContainer":"RwLsnN","banner":"PiVZcf","footerContainer":"EqyXZV","footerActionsContainer":"Rmv08d","errorCount":"XcBZZU"};